import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
import {  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend } from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import {optionsBar, optionsDoughnutCustomer, optionsDoughnutCab,} from './ChartComponentData';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';


ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function ChartComponent(props) {
  const totalRegistration = props?.totalRegistration
  const rideAnalytic = props?.rideAnalytic
  const dailyCustomer = props?.dailyCustomer 

  const loadingRegistration = props.isLoadingRegistration;
  const loadingCustomer = props.isLoadingCustomer;
  const loadingAnalytic = props.isLoadingAnalytic;

  
  return(
    <>
      <Grid container>
        <h1 className='colorBlack font18 marginBottom25 fontMedium'>
          Graph & Analytics
        </h1>
      </Grid>
      <Grid container item className='chartContainer'>
        <Grid item xs={12} sm={6} md={3.3} sx={{marginTop:{xs:'10px', sm:'0px'}}} className="chartStyle">
          {loadingRegistration ? <CircularProgress />  : totalRegistration?.labels?.length > 0 ? <Doughnut 
            id='doughnutChartCar' 
            data={totalRegistration}
            options={optionsDoughnutCab}
            plugins={[
              {
                beforeDraw(chart) {
                  const { ctx } = chart;
                  const { top, bottom, left, right } = chart.chartArea;
                  ctx.save();
                  const fontSize = 28;
                  ctx.font = `bolder ${fontSize}px sans-serif`;
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'end';
                  ctx.fillStyle = '#282828';
                  const text = totalRegistration?.datasets[0]?.data?.reduce((partialSum, a) => partialSum + a, 0);
                  const textX = Math.round((left + right) / 2);
                  const textY = Math.round((top + bottom) / 2);
                  ctx.fillText(text, textX, textY-15);

                  ctx.font = `10px Poppins`;
                  const text2 = 'Trip';
                  ctx.fillStyle = '#969696';
                  ctx.fillText(text2, textX, textY+15);
                },
             },
           ]}
          /> : <CommonNoDataFound />}
        </Grid>
        {props?.role !== 'subVendorCompany' && <Grid item xs={12} sm={6} md={3.3} sx={{marginTop:{xs:'10px', sm:'0px'}}}  className="chartStyle">
          {loadingCustomer ? <CircularProgress />  : dailyCustomer?.labels?.length > 0 ? <Doughnut 
            id='doughnutChart' 
            data={dailyCustomer} 
            options={optionsDoughnutCustomer} 
            plugins={[
              {
                beforeDraw(chart) {
                  const { ctx } = chart;
                  const { top, bottom, left, right } = chart.chartArea;
                  ctx.save();
                  const fontSize = 28;
                  ctx.font = `bolder ${fontSize}px sans-serif`;
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.fillStyle = '#000000';
                  const text = dailyCustomer?.datasets[0]?.data?.reduce((partialSum, a) => partialSum + a, 0);
                  const textX = Math.round((left + right) / 2);
                  const textY = Math.round((top + bottom) / 2);
                  ctx.fillText(text, textX, textY-15);

                  ctx.font = `10px Poppins`;
                  const text2 = 'Riders';
                  ctx.fillStyle = '#969696';
                  ctx.fillText(text2, textX, textY+15);
                },
             },
           ]}
          /> : <CommonNoDataFound />}
        </Grid>}
        <Grid item xs={12} sm={12} md={props?.role === 'subVendorCompany' ? 8.5 : 5} sx={{marginTop:{sm:'10px', md:'0px'}}} className="chartStyle">
          {loadingAnalytic ? <CircularProgress />  : rideAnalytic?.labels?.length > 0 ? <Bar 
            id='barChart' 
            options={optionsBar} 
            data={rideAnalytic} 
          /> : <CommonNoDataFound />}
        </Grid>
      </Grid>
    </>
  )
}